import {
  ChangeDetectionStrategy,
  Component, Inject,
  Input, OnInit
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {FieldValueModel} from "../../../models/field-value.model";
import {VisitPlanCallModel} from "../../../models/visit-plan-call.model";
import {isUndefined} from "lodash";
import * as moment from "moment";
import {VisitPlanAccountCallAnalysisModel} from "../../../models/visit-plan-account-analysis.model";


require('./visit-plan-call-details.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-call-details',
  templateUrl: './visit-plan-call-details.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanCallDetailsComponent implements OnInit {

  @Input() call: VisitPlanCallModel;
  @Input() visitPlan: VisitPlanModel;
  @Input() programTypeAliasMap: { [key: string]: string };
  @Input() analysis: VisitPlanAccountCallAnalysisModel;

  public userZoneId: string;
  public timezoneOffset: number;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.userZoneId = moment.tz.guess();
    this.timezoneOffset = moment.tz.zone(this.userZoneId).utcOffset(moment().valueOf()) - moment.tz.zone(this.visitPlan.zoneId).utcOffset(moment().valueOf());
  }

  getFieldValue<T>(field: FieldValueModel<T>): T | undefined {
    if (!field) {
      return undefined;
    } else if (isUndefined(field.adjusted?.value)) {
      return field.initial?.value
    } else {
      return field.adjusted?.value
    }
  }

}
